import * as React from 'react';
import { IconUsers } from '../../icons';
import { BackofficeRoute } from '../../types/route.interfaces';
import UserDetail from './pages/UserDetail';
import UsersPage from './pages/Users';
import UserSubscriptionPage from './pages/UserSubscriptionPage';

const userRoutes: BackofficeRoute[] = [
  {
    sidebar: {
      icon: IconUsers,
      translationKey: 'menu.users',
    },
    path: '/users',
    element: <UsersPage />,
  },
  {
    path: '/users/:id',
    element: <UserDetail />,
  },
  {
    path: 'users/:id/subscription/',
    element: <UserSubscriptionPage />,
  },
];

export default userRoutes;
